import { useInfiniteQuery, useQuery } from '@tanstack/react-query';
import { auditEventsApi, type AuditEventsFilters } from '../services/auditEventsApi';

export const auditEventsKeys = {
  all: ['auditEvents'] as const,
  lists: () => [...auditEventsKeys.all, 'list'] as const,
  list: (orgId: string, filters: AuditEventsFilters) =>
    [...auditEventsKeys.lists(), orgId, filters] as const,
  catalog: (orgId: string) => [...auditEventsKeys.all, 'catalog', orgId] as const,
};

export function useAuditEvents(orgId: string | undefined, filters: AuditEventsFilters = {}) {
  return useInfiniteQuery({
    queryKey: auditEventsKeys.list(orgId ?? '', filters),
    queryFn: async ({ pageParam }) => {
      const response = await auditEventsApi.list(orgId!, {
        ...filters,
        cursor: pageParam ?? undefined,
      });
      if (!response.success) {
        throw new Error('Failed to fetch audit events');
      }
      return response;
    },
    initialPageParam: null as string | null,
    getNextPageParam: lastPage =>
      lastPage.pagination.has_more ? lastPage.pagination.next_cursor : null,
    enabled: !!orgId,
  });
}

export function useAuditActionsCatalog(orgId: string | undefined) {
  return useQuery({
    queryKey: auditEventsKeys.catalog(orgId ?? ''),
    queryFn: async () => {
      const response = await auditEventsApi.actionsCatalog(orgId!);
      if (!response.success) {
        throw new Error('Failed to fetch audit actions');
      }
      return response.data;
    },
    enabled: !!orgId,
    staleTime: 60 * 60 * 1000,
  });
}
